import * as React from 'react';
import { style, classes } from 'typestyle';
const Label = ({ title, className }) => (React.createElement("label", { className: classes('ta-atom-label', className, labelClassName) }, title));
export default Label;
const labelClassName = style({
    display: 'flex',
    width: 'auto',
});
//# sourceMappingURL=Label.js.map